export default __webpack_public_path__ + "static/KanvasVisualizer-7d853e953fa58d40fd3315f44ba34ba0.webp";